import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31adc729"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ps-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-4" }
const _hoisted_4 = { class: "col-sm-4" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_27 = { class: "ps-3" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-sm-4" }
const _hoisted_30 = { class: "col-sm-4" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_33 = { class: "col-sm-4" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-sm-4" }
const _hoisted_38 = { class: "col-sm-4" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_41 = { class: "col-sm-4" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-sm-4" }
const _hoisted_46 = { class: "col-sm-4" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_49 = { class: "col-sm-4" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-sm-4" }
const _hoisted_54 = { class: "col-sm-4" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_57 = { class: "col-sm-4" }
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_60 = { class: "ps-3" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-sm-4" }
const _hoisted_63 = { class: "col-sm-4" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_66 = { class: "col-sm-4" }
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-sm-4" }
const _hoisted_71 = { class: "col-sm-4" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_74 = { class: "col-sm-4" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-sm-4" }
const _hoisted_79 = { class: "col-sm-4" }
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_82 = { class: "col-sm-4" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-sm-4" }
const _hoisted_87 = { class: "col-sm-4" }
const _hoisted_88 = { class: "form-group" }
const _hoisted_89 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_90 = { class: "col-sm-4" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_93 = { class: "ps-3" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-sm-4" }
const _hoisted_96 = { class: "col-sm-4" }
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_99 = { class: "col-sm-4" }
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_102 = { class: "row" }
const _hoisted_103 = { class: "col-sm-4" }
const _hoisted_104 = { class: "col-sm-4" }
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_107 = { class: "col-sm-4" }
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-sm-4" }
const _hoisted_112 = { class: "col-sm-4" }
const _hoisted_113 = { class: "form-group" }
const _hoisted_114 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_115 = { class: "col-sm-4" }
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-sm-4" }
const _hoisted_120 = { class: "col-sm-4" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_123 = { class: "col-sm-4" }
const _hoisted_124 = { class: "form-group" }
const _hoisted_125 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_126 = { class: "ps-3" }
const _hoisted_127 = { class: "row" }
const _hoisted_128 = { class: "col-sm-4" }
const _hoisted_129 = { class: "col-sm-4" }
const _hoisted_130 = { class: "form-group" }
const _hoisted_131 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_132 = { class: "col-sm-4" }
const _hoisted_133 = { class: "form-group" }
const _hoisted_134 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1))
const _hoisted_136 = { class: "row" }
const _hoisted_137 = { class: "col-sm-6" }
const _hoisted_138 = { class: "form-group" }
const _hoisted_139 = { class: "d-block fs_18 mt-3 pt-1" }
const _hoisted_140 = { class: "col-sm-6" }
const _hoisted_141 = { class: "form-group" }
const _hoisted_142 = { class: "d-block fs_18 mt-3 pt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_form_field, {
      type: "number",
      labelKey: "Hectars (ha)",
      labelValue: "Hectars (ha)",
      placeholderKey: "Hectars (ha)",
      placeholderValue: "Hectars (ha)",
      modelValue: _ctx.model.ha,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.ha) = $event)),
      readonly: _ctx.isReadOnly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(_component_localized_text, {
      localizedKey: "Land preparations",
      text: "Land preparations",
      class: "dividerTitle"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Diesel consumption (liters/ha)",
            labelValue: "Diesel consumption (liters/ha)",
            placeholderKey: "Diesel consumption (tractor)",
            placeholderValue: "Diesel consumption (tractor)",
            modelValue: _ctx.model.landPreparation_DieselLitersHa,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.landPreparation_DieselLitersHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.approximation(_ctx.getLandPreparationDieselKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.approximation(_ctx.getLandPreparationDieselKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_form_field, {
            type: "select",
            labelKey: "Country",
            labelValue: "Country",
            placeholderKey: "Country",
            placeholderValue: "Country",
            list: _ctx.countries,
            modelValue: _ctx.model.landPreparation_FarmingCountry.identifier,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.landPreparation_FarmingCountry.identifier) = $event)),
              _ctx.getCountryEmissionFactor
            ],
            readonly: _ctx.isReadOnly
          }, null, 8, ["list", "modelValue", "onUpdate:modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Electric equipment (kwh/ha)",
            labelValue: "Electric equipment (kwh/ha)",
            placeholderKey: "Electric equipment (tractor)",
            placeholderValue: "Electric equipment (tractor)",
            modelValue: _ctx.model.landPreparation_ElectricKwhHa,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.landPreparation_ElectricKwhHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$filters.approximation(_ctx.getLandPreparationElectricKgCO2e)), 1)
          ])
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Methodology Conventional (%)",
            labelValue: "Methodology Conventional (%)",
            placeholderKey: "Methodology Conventional (%)",
            placeholderValue: "Methodology Conventional (%)",
            modelValue: _ctx.model.landPreparation_ConventionalPercentage,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.landPreparation_ConventionalPercentage) = $event)),
              _ctx.recalculateElectricPercentage
            ],
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Methodology Electric (%)",
            labelValue: "Methodology Electric (%)",
            placeholderKey: "Methodology Electric (%)",
            placeholderValue: "Methodology Electric (%)",
            modelValue: _ctx.model.landPreparation_ElectricPercentage,
            "onUpdate:modelValue": [
              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.landPreparation_ElectricPercentage) = $event)),
              _ctx.recalculateConventionalPercentage
            ],
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_localized_text, {
              localizedKey: "Field levelling (kg CO2e)",
              text: "Field levelling (kg CO2e)",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$filters.approximation(_ctx.getLandPreparationFieldLevellingKgCO2e)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_localized_text, {
              localizedKey: "Field levelling (kg CO2e / ha)",
              text: "Field levelling (kg CO2e / ha)",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$filters.approximation(_ctx.getLandPreparationFieldLevellingKgCO2eHa)), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "Fertilizers",
      text: "Fertilizers",
      class: "dividerTitle"
    }),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Compost (kg/ha)",
            labelValue: "Compost (kg/ha)",
            placeholderKey: "Compost (kg/ha)",
            placeholderValue: "Compost (kg/ha)",
            modelValue: _ctx.model.fertilizer_CompostKgHa,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.fertilizer_CompostKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerCompostKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerCompostKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Cow dung (kg/ha)",
            labelValue: "Cow dung (kg/ha)",
            placeholderKey: "Cow dung (kg/ha)",
            placeholderValue: "Cow dung (kg/ha)",
            modelValue: _ctx.model.fertilizer_CowDungKgHa,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.fertilizer_CowDungKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerCowDungKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerCowDungKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Farm yard manure (kg/ha)",
            labelValue: "Farm yard manure (kg/ha)",
            placeholderKey: "Farm yard manure (kg/ha)",
            placeholderValue: "Farm yard manure (kg/ha)",
            modelValue: _ctx.model.fertilizer_FarmYardManureKgHa,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.fertilizer_FarmYardManureKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerYardManureKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerYardManureKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Urea (kg/ha)",
            labelValue: "Urea (kg/ha)",
            placeholderKey: "Urea (kg/ha)",
            placeholderValue: "Urea (kg/ha)",
            modelValue: _ctx.model.fertilizer_UreaKgHa,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.fertilizer_UreaKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerUreaKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$filters.approximation(_ctx.getFertilizerUreaKgCO2e)), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "Inputs",
      text: "Inputs",
      class: "dividerTitle"
    }),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Seed (kg/ha)",
            labelValue: "Seed (kg/ha)",
            placeholderKey: "Seed (kg/ha)",
            placeholderValue: "Seed (kg/ha)",
            modelValue: _ctx.model.input_SeedKgHa,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.input_SeedKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputSeedKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputSeedKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "DAP (kg/ha)",
            labelValue: "DAP (kg/ha)",
            placeholderKey: "DAP (Diammonium phosphate)",
            placeholderValue: "DAP (Diammonium phosphate)",
            modelValue: _ctx.model.input_DAPKgHa,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.input_DAPKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputDAPKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputDAPKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Potash (kg/ha)",
            labelValue: "Potash (kg/ha)",
            placeholderKey: "Potash (kg/ha)",
            placeholderValue: "Potash (kg/ha)",
            modelValue: _ctx.model.input_PotashKgHa,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.input_PotashKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputPotashKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputPotashKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_85, [
        _createElementVNode("div", _hoisted_86, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Irrigation - water (m3/ha)",
            labelValue: "Irrigation - water (m3/ha)",
            placeholderKey: "Irrigation - water (m3/ha)",
            placeholderValue: "Irrigation - water (m3/ha)",
            modelValue: _ctx.model.input_IrrigationM3Ha,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.input_IrrigationM3Ha) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputIrrigationKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$filters.approximation(_ctx.getInputIrrigationKgCO2e)), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "Pesticide - Active Ingredient",
      text: "Pesticide - Active Ingredient",
      class: "dividerTitle"
    }),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Imidacloprid (kg/ha)",
            labelValue: "Imidacloprid (kg/ha)",
            placeholderKey: "Imidacloprid (kg/ha)",
            placeholderValue: "Imidacloprid (kg/ha)",
            modelValue: _ctx.model.pesticide_ImidaclopridKgHa,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.pesticide_ImidaclopridKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideImidaclopridKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideImidaclopridKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_102, [
        _createElementVNode("div", _hoisted_103, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Monocrotophos (kg/ha)",
            labelValue: "Monocrotophos (kg/ha)",
            placeholderKey: "Monocrotophos (kg/ha)",
            placeholderValue: "Monocrotophos (kg/ha)",
            modelValue: _ctx.model.pesticide_MonocrotophosKgHa,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.model.pesticide_MonocrotophosKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideMonocrotophosKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideMonocrotophosKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_110, [
        _createElementVNode("div", _hoisted_111, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Acephate (kg/ha)",
            labelValue: "Acephate (kg/ha)",
            placeholderKey: "Acephate (kg/ha)",
            placeholderValue: "Acephate (kg/ha)",
            modelValue: _ctx.model.pesticide_AcephateKgHa,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.pesticide_AcephateKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_112, [
          _createElementVNode("div", _hoisted_113, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideAcephateKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_115, [
          _createElementVNode("div", _hoisted_116, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideAcephateKgCO2e)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_118, [
        _createElementVNode("div", _hoisted_119, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Profenofos (kg/ha)",
            labelValue: "Profenofos (kg/ha)",
            placeholderKey: "Profenofos (kg/ha)",
            placeholderValue: "Profenofos (kg/ha)",
            modelValue: _ctx.model.pesticide_ProfenofosKgHa,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.pesticide_ProfenofosKgHa) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_120, [
          _createElementVNode("div", _hoisted_121, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideProfenofosKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_123, [
          _createElementVNode("div", _hoisted_124, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.$filters.approximation(_ctx.getPesticideProfenofosKgCO2e)), 1)
          ])
        ])
      ])
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "Yield",
      text: "Yield",
      class: "dividerTitle"
    }),
    _createElementVNode("div", _hoisted_126, [
      _createElementVNode("div", _hoisted_127, [
        _createElementVNode("div", _hoisted_128, [
          _createVNode(_component_form_field, {
            type: "number",
            labelKey: "Cotton seed production (kg/ha)",
            labelValue: "Cotton seed production (kg/ha)",
            placeholderKey: "Cotton seed production (kg/ha)",
            placeholderValue: "Cotton seed production (kg/ha)",
            modelValue: _ctx.model.yield_CottonSeedProduction,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.yield_CottonSeedProduction) = $event)),
            readonly: _ctx.isReadOnly
          }, null, 8, ["modelValue", "readonly"])
        ]),
        _createElementVNode("div", _hoisted_129, [
          _createElementVNode("div", _hoisted_130, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e/ha",
              text: "kg CO2e/ha",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.$filters.approximation(_ctx.getYieldCottonSeedKgCO2eHa)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createVNode(_component_localized_text, {
              localizedKey: "kg CO2e",
              text: "kg CO2e",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.$filters.approximation(_ctx.getYieldCottonSeedKgCO2e)), 1)
          ])
        ])
      ]),
      _hoisted_135,
      _createElementVNode("div", _hoisted_136, [
        _createElementVNode("div", _hoisted_137, [
          _createElementVNode("div", _hoisted_138, [
            _createVNode(_component_localized_text, {
              localizedKey: "Harvesting (by complete harvester)",
              text: "Harvesting (by complete harvester)",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.$filters.approximation(_ctx.getYieldHarvesting)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_140, [
          _createElementVNode("div", _hoisted_141, [
            _createVNode(_component_localized_text, {
              localizedKey: "Cotton seed emissions (kg CO2e/kg)",
              text: "Cotton seed emissions (kg CO2e/kg)",
              type: "label",
              class: "input_title"
            }),
            _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.$filters.approximation(_ctx.getCottonEmissionFactor)), 1)
          ])
        ])
      ])
    ])
  ], 64))
}